export default "__VITE_ASSET__C6XI5a38__"